import script from "./PermissoesAcessoSelector.vue?vue&type=script&setup=true&lang=js"
export * from "./PermissoesAcessoSelector.vue?vue&type=script&setup=true&lang=js"

import "./PermissoesAcessoSelector.vue?vue&type=style&index=0&id=05073031&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-05073031"]])

export default __exports__